import { Actions } from 'flummox';
import Immutable from 'immutable';
import Config from 'config';

const addSection = (section, key) => {
  if (section.get('sections')) {
    let containerSection = {};
    containerSection.type = "container";
    containerSection.tags = [key];
    containerSection.sections = [];
    section.get('sections').forEach((section, key) => {
      let sectionJS = addSection(section, key);
      containerSection.sections.push(sectionJS);
    });

    return containerSection;
  }

  return section.toJS();
}

const updateJSON = (store) => {
  let pageSections = {};
  pageSections.sections = [];
  store.state.get('sections').forEach((section, key) => {
    let sectionJS = addSection(section, key);
    pageSections.sections.push(sectionJS);
  });

  return new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          resolve({xhr});
        } else {
          reject();
        }
      }
    };

    let cmsloader = document.getElementById('cmsloader');

    let loaderQuery = cmsloader.src.replace(/^[^\?]+\??/,'').split("&");
    let dataFile;
    loaderQuery.forEach((queryString) => {
      if (queryString.indexOf("data=") === 0) {
        dataFile = queryString.substr(5);
      }
    });

    pageSections.location = dataFile;

    xhr.open('POST', Config.UPDATE_PAGE);
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xhr.setRequestHeader("AUTH-TOKEN", Config.authToken);
    xhr.send(JSON.stringify(pageSections));
  });
};

export default class SectionActions extends Actions {
  addSection(path, data) {
    return {path, data}; // automatically dispatched
  }

  updateSection(path, data, save) {
    return {path, data, save};
  }

  updateSectionProperties(path, data) {
    return {path, data};
  }

  async saveState(store) {
    try {
      const response = await updateJSON(store);
      await response;
      return {status: "success"};
    } catch (error) {
      alert(error);
    }
  }
}



// WEBPACK FOOTER //
// ./src/flux/SectionActions.js